/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @param {Function} createAction - Acción redux para crear el recurso.
 * @param {Function} updateAction - Acción redux para actualizar el recurso.
 * @param {string} title - Clave de traducción para el título del recurso.
 * @param {Object} data - Datos actuales si es actualización.
 * @param {boolean} isUpdate - Indica si es modo edición.
 */


import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {useEffect, useState} from "react";
import CustomModal from "./CustomModal";
import DivContainerBody from "../DivContainerBody";
import {CustomTextField} from "../CustomTextField";
import {toast} from "react-toastify";
import {CreateServiceType} from "../../reduxToolkit/ServiceType/ServiceTypeApi";
import {errorCodeTranslation} from "../../Apis/ErrorCode";

const CustomAddNewEntityModal = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        createAction,
        updateAction,
        title,
        isUpdate,
        data,
        show,
        onHide,
    } = props;

    const [name, setName] = useState('');
    const [submitClicked, setSubmitClicked] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);

    const resetValues = () => {
        setName('');
        setEmptyFields(false)
    };

    const handleChange = (e) => {
        setName(e.target.value);
    };

    const handleSubmit = () => {
        if (!name.trim()) {
            setEmptyFields(true);
            setSubmitClicked(true);
            return;
        }

        const payload = isUpdate ? { id: data?.id, name } : { name };
        const action = isUpdate ? updateAction(payload) : createAction(payload);

        dispatch(action)
            .then(({payload:{data:{data,success,code}}}) => {
                if (success) {
                    if (props.isUpdate) {
                        toast.success(t('has_been_updated_successfully'));
                    } else {
                        toast.success(t('has_been_created_successfully'));
                    }
                    setEmptyFields(false);
                    setSubmitClicked(false);
                    props.setModified(!props.modified)
                    resetValues();
                    props.onHide();
                } else {
                    const errorMessage = errorCodeTranslation[code] ? t(errorCodeTranslation[code]) : t('something_went_wrong_2');
                    toast.error(errorMessage);
                }
            })
    };

    useEffect(() => {
        if (isUpdate && data) {
            setName(data.name || '');
            setEmptyFields(false);
        } else {
            resetValues();
        }
    }, [isUpdate, data]);

    return (
        <CustomModal
            {...props}
            show={show}
            title={isUpdate ? `${t('update')} ${t(title)}` : `${t('create')} ${t(title)}`}
            size='mb'
            onConfirm={handleSubmit}
            onHide={() => {
                onHide();
                resetValues();
            }}
            classNameBody="pt-2"
        >
            <DivContainerBody>
                <div className="mt-2">
                    <CustomTextField
                        id="txt_generic_name"
                        name="name"
                        value={name}
                        trans="name"
                        emptyFields={emptyFields}
                        required={true}
                        onChange={handleChange}
                        length = {32}
                    />
                </div>
            </DivContainerBody>
        </CustomModal>
    );
};
export default CustomAddNewEntityModal
